import React from 'react';
import { graphql } from 'gatsby';

import StorySectionDS from 'design-system/src/components/organisms/StorySection';
import { getImage } from '../../utils/media';

export default function StorySection({ media, ...props }: any) {
    return <StorySectionDS {...props} media={getImage(media)} />;
}

export const query = graphql`
    fragment DatoCmsStorySection on DatoCmsStorySection {
        title
        text
        media {
            ...SourceMedia
            gatsbyImageData(width: 1508, placeholder: BLURRED)
        }
    }
`;
